<app-background-image data-state="storage"></app-background-image>
<app-topbar></app-topbar>

<app-sidebar class="d-print-none">
    <div class="sidebar-header"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block" (click)="back()">
                <fa-icon [icon]="faBack"></fa-icon>
                <span style="padding-left: 10px">Back</span>
            </button>
        </li>
    </ul>
</app-sidebar>
<ng-container>
    <div class="main-content">
        <div class="table-container">
            <div>
                <div class="main-content-header">
                    <h3 id="storageitemdetails-header">Storage item details</h3>
                    <a
                        href="javascript:;"
                        class="btn btn-link printlink"
                        (click)="triggerprint()"
                        ><fa-icon [icon]="faPrint"></fa-icon
                    ></a>
                </div>
                <app-card headline="Storage item">
                    <app-card-body>
                        <div style="padding: 10px">
                            <table *ngIf="storageItem">
                                <tbody>
                                    <tr>
                                        <td>Description</td>
                                        <td>{{ storageItem.description }}</td>
                                    </tr>
                                    <tr>
                                        <td>Quantity</td>
                                        <td>{{ storageItem.quantity }}</td>
                                    </tr>
                                    <tr>
                                        <td>ExternalId</td>
                                        <td>{{ storageItem.externalId }}</td>
                                    </tr>
                                    <tr>
                                        <td>Unit of measure</td>
                                        <td>
                                            {{ storageItem.baseUnitOfMeasure }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Fire Class</td>
                                        <td>{{ storageItem.fireClass }}</td>
                                    </tr>
                                    <tr *ngIf="storageItem.cO2Consumption">
                                        <td>Total annual CO2 emissions (based on warehouse and machinery handling)</td>
                                        <td>
                                            {{
                                                storageItem.cO2Consumption
                                                    | number : "1.0" : "da-DK"
                                            }}
                                            KGS
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </app-card-body>
                </app-card>
                <div class="page-break"></div>
                <app-card
                    headline="Stock Chart"
                    [collapsed]="true"
                    (opened)="accumulatedQuantityOpened($event)"
                    s
                >
                    <app-card-body>
                        <div
                            *ngIf="
                                accumulatedQuantityShow &&
                                storageItem &&
                                storageItem.id
                            "
                            style="padding: 1.25rem"
                        >
                            <app-storage-quantity-accumulate
                                [storageItem]="storageItem"
                            ></app-storage-quantity-accumulate>
                        </div>
                    </app-card-body>
                </app-card>
                <div class="page-break"></div>
                <app-card
                    headline="Movement chart"
                    [collapsed]="true"
                    (opened)="movementChartOpened($event)"
                >
                    <app-card-body style="padding: 10px">
                        <div
                            *ngIf="
                                storageItem &&
                                    storageItem.movementYears &&
                                    storageItem.movementYears.length > 0;
                                else movementChartEmpty
                            "
                        >
                            <div
                                class="form-group year-selector"
                                *ngIf="storageItem"
                            >
                                <label for="movement-year-selector"
                                    >Select year</label
                                >
                                <select
                                    id="movement-year-selector"
                                    class="form-control"
                                    [formControl]="movementYearSelectorControl"
                                >
                                    <option value="" disabled selected>
                                        Select year
                                    </option>
                                    <option
                                        value="{{ year }}"
                                        *ngFor="
                                            let year of storageItem.movementYears
                                        "
                                    >
                                        {{ year }}
                                    </option>
                                </select>
                            </div>

                            <div class="chart-container">
                                <app-bar-chart
                                    [data]="chartJsData"
                                    *ngIf="movementChartShow"
                                ></app-bar-chart>
                            </div>
                        </div>
                        <ng-template #movementChartEmpty>
                            <div style="margin-left: 20px">
                                No Movements yet.
                            </div>
                        </ng-template>
                    </app-card-body>
                </app-card>
                <div class="page-break"></div>
                <app-card
                    headline="Movements"
                    [collapsed]="true"
                    (opened)="movementsOpened($event)"
                >
                    <app-card-body>
                        <div
                            *ngIf="
                                movementsShow && storageItem && storageItem.id
                            "
                            style="padding: 1.25rem"
                        >
                            <app-storage-item-movements
                                [storageItemId]="storageItem.id"
                            ></app-storage-item-movements>
                        </div>
                    </app-card-body>
                </app-card>
                <div class="page-break"></div>

                <app-card
                    headline="Bins"
                    [collapsed]="true"
                    (opened)="binsOpened($event)"
                >
                    <app-card-body>
                        <div
                            *ngIf="binsShow && storageItem && storageItem.id"
                            style="padding: 1.25rem"
                        >
                            <app-storage-item-bins
                                [storageItemId]="storageItem.id"
                            ></app-storage-item-bins>
                        </div>
                    </app-card-body>
                </app-card>
                <div class="page-break"></div>
                <app-card
                    headline="Tanks"
                    [collapsed]="true"
                    (opened)="tanksOpened($event)"
                    *ngIf="!hidden"
                >
                    <app-card-body>
                        <div
                            *ngIf="tanksShow && storageItem && storageItem.id"
                            style="padding: 1.25rem"
                        >
                            <app-storage-tanks
                                [storageItemId]="storageItem.id"
                            ></app-storage-tanks>
                        </div>
                    </app-card-body>
                </app-card>
            </div>
        </div>
    </div>
</ng-container>
